import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(`as-goals-scored`)
}
const _hoisted_2 = { class: "as-goals-scored__head" }
const _hoisted_3 = { class: "as-history" }
const _hoisted_4 = { class: "as-history-item" }
const _hoisted_5 = { class: "as-history-item__head" }
const _hoisted_6 = {
  key: 0,
  class: "as-history-item__body"
}
const _hoisted_7 = { class: "as-competition" }
const _hoisted_8 = { class: "as-competition__table" }
const _hoisted_9 = { class: "as-center a" }
const _hoisted_10 = { class: "as-center a" }
const _hoisted_11 = { class: "as-competition" }
const _hoisted_12 = { class: "as-competition__table" }
const _hoisted_13 = { class: "as-center a" }
const _hoisted_14 = { class: "as-center a" }
const _hoisted_15 = {
  key: 1,
  class: "as-history-item__body"
}
const _hoisted_16 = {
  key: 0,
  class: "as-competition"
}
const _hoisted_17 = { class: "as-competition__table" }
const _hoisted_18 = { class: "as-center a" }
const _hoisted_19 = { class: "as-center a" }
const _hoisted_20 = { class: "as-competition__table" }
const _hoisted_21 = { class: "as-center a" }
const _hoisted_22 = { class: "as-center a" }

import IconCorner from "~src/components/icons/foot_stats/IconCorner.vue";
import type { IMatch } from "~src/interfaces";
import type {
  IFootyStats,
  ITeam,
  IStatsParent,
} from "~src/interfaces/footystats";
import { ref, computed } from "vue";
import { getClassForItem } from "~src/helpers/footystats";


const __default__ = {};

interface Props {
  match: IMatch;
  mode?: string;
  footyStats: IFootyStats | null;
  homeTeamInfo: ITeam | null;
  awayTeamInfo: ITeam | null;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TeamCornerKick',
  props: {
    match: {},
    mode: { default: "as-win" },
    footyStats: {},
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

const props = __props;

const activeTab = ref("all");
const setActiveTab = (tab: string) => {
  activeTab.value = tab;
};

const homeTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
});

const awayTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
});

const getValueWithMode = (team = "home", mode = "btts", mode_half = "") => {
  const __data: IStatsParent =
    team === "home" ? homeTeamLastX.value : awayTeamLastX.value;
  let __mode = mode;
  if (mode_half) {
    __mode = mode_half;
  }
  if (!__data || !__data.stats || !__data.stats.hasOwnProperty(__mode)) {
    return 0;
  }

  return __data.stats[__mode] as number;
};

const calculatorAVG = (home: number, away: number) => {
  const _avg = (home + away) / 2;

  return Math.round(_avg);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IconCorner),
      _cache[2] || (_cache[2] = _createElementVNode("span", null, " Phạt góc đội ", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab", { 'as-active': activeTab.value === 'all' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('all')))
          }, " Cả trận ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab", { 'as-active': activeTab.value === 'half' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('half')))
          }, " Hiệp 1/2 ", 2)
        ]),
        (activeTab.value === 'all')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[3] || (_cache[3] = _createElementVNode("th", null, "PG kiếm được", -1)),
                      _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.footyStats?.home_name), 1),
                      _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.footyStats?.away_name), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("th", { class: "as-center a" }, "Trung bình", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("td", null, "Trên 2.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'home',
                        'over25CornersForPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "home",
                        "over25CornersForPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'away',
                        'over25CornersForPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "away",
                        "over25CornersForPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over25CornersForPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over25CornersForPercentage_overall"
                        )
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("td", null, "Trên 3.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'home',
                        'over35CornersForPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "home",
                        "over35CornersForPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'away',
                        'over35CornersForPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "away",
                        "over35CornersForPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over35CornersForPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over35CornersForPercentage_overall"
                        )
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("td", null, "Trên 4.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'home',
                        'over45CornersForPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "home",
                        "over45CornersForPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'away',
                        'over45CornersForPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "away",
                        "over45CornersForPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over45CornersForPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over45CornersForPercentage_overall"
                        )
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[8] || (_cache[8] = _createElementVNode("td", null, "Trên 5.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'home',
                        'over55CornersForPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "home",
                        "over55CornersForPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'away',
                        'over55CornersForPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "away",
                        "over55CornersForPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over55CornersForPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over55CornersForPercentage_overall"
                        )
                      )) + "% ", 3)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("table", _hoisted_12, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("th", null, "PG chống lại", -1)),
                      _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.footyStats?.home_name), 1),
                      _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.footyStats?.away_name), 1),
                      _cache[10] || (_cache[10] = _createElementVNode("th", { class: "as-center a" }, "Trung bình", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("td", null, "Trên 2.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'home',
                        'over25CornersAgainstPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "home",
                        "over25CornersAgainstPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'away',
                        'over25CornersAgainstPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "away",
                        "over25CornersAgainstPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over25CornersAgainstPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over25CornersAgainstPercentage_overall"
                        )
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[12] || (_cache[12] = _createElementVNode("td", null, "Trên 3.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'home',
                        'over35CornersAgainstPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "home",
                        "over35CornersAgainstPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'away',
                        'over35CornersAgainstPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "away",
                        "over35CornersAgainstPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over35CornersAgainstPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over35CornersAgainstPercentage_overall"
                        )
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[13] || (_cache[13] = _createElementVNode("td", null, "Trên 4.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'away',
                        'over45CornersAgainstPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "home",
                        "over45CornersAgainstPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'away',
                        'over45CornersAgainstPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "away",
                        "over45CornersAgainstPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over45CornersAgainstPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over45CornersAgainstPercentage_overall"
                        )
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[14] || (_cache[14] = _createElementVNode("td", null, "Trên 5.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'home',
                        'over55CornersAgainstPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "home",
                        "over55CornersAgainstPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode(
                        'away',
                        'over55CornersAgainstPercentage_overall'
                      )
                    )}`)
                      }, _toDisplayString(getValueWithMode(
                        "away",
                        "over55CornersAgainstPercentage_overall"
                      )) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'over85Corners_overall')
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over55CornersAgainstPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over55CornersAgainstPercentage_overall"
                        )
                      )) + "% ", 3)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (activeTab.value === 'half')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (activeTab.value === 'half')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("table", _hoisted_17, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _cache[15] || (_cache[15] = _createElementVNode("th", null, "First Half", -1)),
                          _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.footyStats?.home_name), 1),
                          _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.footyStats?.away_name), 1),
                          _cache[16] || (_cache[16] = _createElementVNode("th", { class: "as-center a" }, "Trung bình", -1))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[17] || (_cache[17] = _createElementVNode("td", null, "FH Average", -1)),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'corners_2h_avg_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("home", "corners_2h_avg_overall")), 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('away', 'corners_2h_avg_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("away", "corners_2h_avg_overall")), 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_2h_avg_overall'),
                        getValueWithMode('away', 'corners_2h_avg_overall')
                      )
                    )}`)
                          }, _toDisplayString(calculatorAVG(
                        getValueWithMode("home", "corners_2h_avg_overall"),
                        getValueWithMode("away", "corners_2h_avg_overall")
                      )), 3)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[18] || (_cache[18] = _createElementVNode("td", null, "FH Over 4", -1)),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'corners_fh_over4_percentage_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("home", "corners_fh_over4_percentage_overall")) + "% ", 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('away', 'corners_fh_over4_percentage_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("away", "corners_fh_over4_percentage_overall")) + "% ", 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_fh_over4_percentage_overall'),
                        getValueWithMode('away', 'corners_fh_over4_percentage_overall')
                      )
                    )}`)
                          }, _toDisplayString(calculatorAVG(
                        getValueWithMode("home", "corners_fh_over4_percentage_overall"),
                        getValueWithMode("away", "corners_fh_over4_percentage_overall")
                      )) + "% ", 3)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[19] || (_cache[19] = _createElementVNode("td", null, "FH Over 5", -1)),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'corners_fh_over5_percentage_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("home", "corners_fh_over5_percentage_overall")) + "% ", 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('away', 'corners_fh_over5_percentage_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("away", "corners_fh_over5_percentage_overall")) + "% ", 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_fh_over5_percentage_overall'),
                        getValueWithMode('away', 'corners_fh_over5_percentage_overall')
                      )
                    )}`)
                          }, _toDisplayString(calculatorAVG(
                        getValueWithMode("home", "corners_fh_over5_percentage_overall"),
                        getValueWithMode("away", "corners_fh_over5_percentage_overall")
                      )) + "% ", 3)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[20] || (_cache[20] = _createElementVNode("td", null, "FH Over 6", -1)),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'corners_fh_over6_percentage_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("home", "corners_fh_over6_percentage_overall")) + "% ", 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('away', 'corners_fh_over6_percentage_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("away", "corners_fh_over6_percentage_overall")) + "% ", 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_fh_over6_percentage_overall'),
                        getValueWithMode('away', 'corners_fh_over6_percentage_overall')
                      )
                    )}`)
                          }, _toDisplayString(calculatorAVG(
                        getValueWithMode("home", "corners_fh_over6_percentage_overall"),
                        getValueWithMode("away", "corners_fh_over6_percentage_overall")
                      )) + "% ", 3)
                        ])
                      ])
                    ]),
                    _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("table", _hoisted_20, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _cache[21] || (_cache[21] = _createElementVNode("th", null, "Second Half", -1)),
                          _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.footyStats?.home_name), 1),
                          _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.footyStats?.away_name), 1),
                          _cache[22] || (_cache[22] = _createElementVNode("th", { class: "as-center a" }, "Trung bình", -1))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[23] || (_cache[23] = _createElementVNode("td", null, "FH Average", -1)),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'corners_2h_avg_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("home", "corners_2h_avg_overall")), 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('away', 'corners_2h_avg_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("away", "corners_2h_avg_overall")), 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_2h_avg_overall'),
                        getValueWithMode('away', 'corners_2h_avg_overall')
                      )
                    )}`)
                          }, _toDisplayString(calculatorAVG(
                        getValueWithMode("home", "corners_2h_avg_overall"),
                        getValueWithMode("away", "corners_2h_avg_overall")
                      )), 3)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[24] || (_cache[24] = _createElementVNode("td", null, "FH Over 4", -1)),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'corners_2h_over4_percentage_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("home", "corners_2h_over4_percentage_overall")) + "% ", 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('away', 'corners_2h_over4_percentage_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("away", "corners_2h_over4_percentage_overall")) + "% ", 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_2h_over4_percentage_overall'),
                        getValueWithMode('away', 'corners_2h_over4_percentage_overall')
                      )
                    )}`)
                          }, _toDisplayString(calculatorAVG(
                        getValueWithMode("home", "corners_2h_over4_percentage_overall"),
                        getValueWithMode("away", "corners_2h_over4_percentage_overall")
                      )) + "% ", 3)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[25] || (_cache[25] = _createElementVNode("td", null, "FH Over 5", -1)),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'corners_2h_over5_percentage_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("home", "corners_2h_over5_percentage_overall")) + "% ", 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('away', 'corners_2h_over5_percentage_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("away", "corners_2h_over5_percentage_overall")) + "% ", 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_2h_over5_percentage_overall'),
                        getValueWithMode('away', 'corners_2h_over5_percentage_overall')
                      )
                    )}`)
                          }, _toDisplayString(calculatorAVG(
                        getValueWithMode("home", "corners_2h_over5_percentage_overall"),
                        getValueWithMode("away", "corners_2h_over5_percentage_overall")
                      )) + "% ", 3)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[26] || (_cache[26] = _createElementVNode("td", null, "FH Over 6", -1)),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('home', 'corners_2h_over6_percentage_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("home", "corners_2h_over6_percentage_overall")) + "% ", 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      getValueWithMode('away', 'corners_2h_over6_percentage_overall')
                    )}`)
                          }, _toDisplayString(getValueWithMode("away", "corners_2h_over6_percentage_overall")) + "% ", 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        getValueWithMode('home', 'corners_2h_over6_percentage_overall'),
                        getValueWithMode('away', 'corners_2h_over6_percentage_overall')
                      )
                    )}`)
                          }, _toDisplayString(calculatorAVG(
                        getValueWithMode("home", "corners_2h_over6_percentage_overall"),
                        getValueWithMode("away", "corners_2h_over6_percentage_overall")
                      )) + "% ", 3)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})